<div class="emoji-wrapper">
  <button
    type="button"
    class="emoji-trigger-btn"
    [disabled]="disabled()"
    (click)="toggleEmojiOverlay()"
    #emojiButton>
    <so-svg-icon-ui
      name="sentiment_satisfied"
      [color]="buttonColor()"
      [size]="24 * scale()">
    </so-svg-icon-ui>
  </button>
</div>

<ng-template #emojiPanel>
  <div class="emoji-panel" #panelContainer>
    <div class="triangle" [ngClass]="triangleDir()"></div>
    <emoji-mart
      emoji="point_up"
      (emojiClick)="addEmoji($event)"
      [showPreview]="false"
      [i18n]="i18n"
      [set]="'facebook'"
      [darkMode]="false"
      [color]="'var(--so-secondary)'"
      [emojisToShowFilter]="getEmojisToShow()"
      [enableSearch]="false">
    </emoji-mart>
  </div>
</ng-template>
